const selector = "apexUnbindKendo";

/**
 * Unbind an event handler of a particular type from a particular event.
 * Usage:
 * @example
 * <input kendo-numeric-text-box
 *        apex-unbind-kendo="{ dataKey: 'kendoNumericTextBox', eventName: 'keydown' }" />
 */
export function UnbindKendoDirective() {
    return {
        selector,
        restrict: "A",
        link: {
            post: function postLink(scope, el, attr) {
                const options = parseAttrOptions(scope, attr);
                if (!options) {
                    return;
                }
                el.data(options.dataKey).element.unbind(options.eventName);
            }
        }
    }
}

function parseAttrOptions(scope, attr) {
    try {
        const options = scope.$eval(attr[selector]);
        if (!options.dataKey) {
            options.dataKey = inferKendoDataKey(attr);
        }
        if (!options.dataKey) {
            console.error("UnbindKendo requires data key in options");
            return null;
        }
        if (!options.eventName) {
            console.error("UnbindKendo requires an event name in options");
            return null;
        }
        return options;
    } catch {
        console.error("Invalid arguments for UnbindKendo", attr.apexUnbindKendo);
        return null;
    }
}

function inferKendoDataKey(attr) {
    const potentialKeys = Object.keys(attr).filter(key => key.indexOf("kendo") === 0);
    if (potentialKeys.length !== 1) {
        return null;
    }
    return potentialKeys[0];
}
